const PlungerIcon = ({ color, height = '32px', width = '32px' }) => (
  <svg
    width={width}
    height={height}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 64 86"
    fill="none"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    data-testid="plunger"
  >
    <title>a-icons / 32px / services / plunger</title>
    <mask
      id="mask0_1364_5082"
      style={{ maskType: 'alpha' }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="64"
      height="86"
    >
      <rect width="64" height="86" fill="#C4C4C4" />
    </mask>
    <g mask="url(#mask0_1364_5082)">
      <mask id="path-2-inside-1_1364_5082" fill="white">
        <path d="M11.0461 75.2823C10.5023 75.3616 9.9919 74.995 9.92746 74.4573C9.56741 71.4534 9.79955 68.4134 10.6145 65.5058C11.5172 62.2854 13.1138 59.3027 15.2963 56.7596C17.4788 54.2165 20.1961 52.1724 23.2644 50.7657C26.3326 49.359 29.6801 48.6226 33.0802 48.6063C36.4804 48.59 39.8537 49.2941 42.9719 50.6711C46.0901 52.0481 48.8803 54.0658 51.1536 56.5875C53.4269 59.1092 55.1303 62.0761 56.1484 65.2874C57.0649 68.1785 57.4068 71.2069 57.1586 74.2054C57.1131 74.7542 56.6019 75.1387 56.0475 75.0635V75.0635C55.5014 74.9895 55.1191 74.4966 55.1622 73.9559C55.3794 71.2317 55.0649 68.4819 54.2323 65.8557C53.3004 62.9162 51.7411 60.2003 49.6601 57.8919C47.5791 55.5835 45.025 53.7365 42.1706 52.476C39.3162 51.2155 36.2282 50.5709 33.1158 50.5859C30.0033 50.6008 26.939 51.2749 24.1303 52.5626C21.3216 53.8503 18.8342 55.7215 16.8363 58.0494C14.8385 60.3774 13.377 63.1078 12.5506 66.0557C11.8137 68.6847 11.5974 71.432 11.9098 74.1489C11.9725 74.6942 11.5973 75.2019 11.0461 75.2823V75.2823Z" />
      </mask>
      <path
        d="M11.0461 75.2823C10.5023 75.3616 9.9919 74.995 9.92746 74.4573C9.56741 71.4534 9.79955 68.4134 10.6145 65.5058C11.5172 62.2854 13.1138 59.3027 15.2963 56.7596C17.4788 54.2165 20.1961 52.1724 23.2644 50.7657C26.3326 49.359 29.6801 48.6226 33.0802 48.6063C36.4804 48.59 39.8537 49.2941 42.9719 50.6711C46.0901 52.0481 48.8803 54.0658 51.1536 56.5875C53.4269 59.1092 55.1303 62.0761 56.1484 65.2874C57.0649 68.1785 57.4068 71.2069 57.1586 74.2054C57.1131 74.7542 56.6019 75.1387 56.0475 75.0635V75.0635C55.5014 74.9895 55.1191 74.4966 55.1622 73.9559C55.3794 71.2317 55.0649 68.4819 54.2323 65.8557C53.3004 62.9162 51.7411 60.2003 49.6601 57.8919C47.5791 55.5835 45.025 53.7365 42.1706 52.476C39.3162 51.2155 36.2282 50.5709 33.1158 50.5859C30.0033 50.6008 26.939 51.2749 24.1303 52.5626C21.3216 53.8503 18.8342 55.7215 16.8363 58.0494C14.8385 60.3774 13.377 63.1078 12.5506 66.0557C11.8137 68.6847 11.5974 71.432 11.9098 74.1489C11.9725 74.6942 11.5973 75.2019 11.0461 75.2823V75.2823Z"
        stroke={color || '#00008F'}
        strokeWidth="4"
        mask="url(#path-2-inside-1_1364_5082)"
      />
      <path
        d="M16.0377 67.6058C16.037 67.6057 16.0362 67.6057 16.0353 67.6055C17.0546 63.8288 19.0278 60.3949 21.7662 57.6285C21.767 57.6291 21.7678 57.6299 21.7687 57.6309C21.7721 57.6346 21.7733 57.637 21.7742 57.6394C21.7754 57.6426 21.777 57.6487 21.7767 57.6577C21.7763 57.6768 21.7685 57.6982 21.7509 57.716C19.0555 60.4524 17.1089 63.8358 16.0901 67.5522C16.084 67.5744 16.0705 67.5904 16.0554 67.5995C16.0483 67.6038 16.043 67.6052 16.0405 67.6056C16.0397 67.6057 16.0388 67.6058 16.0377 67.6058Z"
        stroke={color || '#00008F'}
        strokeWidth="2"
      />
      <path
        d="M36.5271 5V43.5H29.5271V5C29.5271 3.067 31.0941 1.5 33.0271 1.5C34.9601 1.5 36.5271 3.067 36.5271 5Z"
        stroke={color || '#00008F'}
        strokeWidth="3"
      />
      <path
        d="M6.09375 77.9048L58.0937 77.9048C59.4745 77.9048 60.5937 79.0241 60.5937 80.4048C60.5937 81.7855 59.4745 82.9048 58.0937 82.9048L6.09375 82.9048C4.71304 82.9048 3.59375 81.7855 3.59375 80.4048C3.59375 79.0241 4.71304 77.9048 6.09375 77.9048Z"
        stroke={color || '#00008F'}
        strokeWidth="2"
      />
      <rect
        x="26.0098"
        y="44.8511"
        width="14.5958"
        height="4.80447"
        stroke={color || '#00008F'}
        strokeWidth="2"
      />
    </g>
  </svg>
);

export default PlungerIcon;
